'use client'

import {usePathname} from 'next/navigation'
import {useEffect} from 'react'
import {capturePageview} from '@/lib/analytics'

/**
 * Sends a `$pageview` on first load and on every client-side navigation.
 *
 * Keyed on the pathname only: a query-string change (a new search filter) is
 * the same page, and `useSearchParams` would force a Suspense boundary onto
 * every route. Renders nothing; without a PostHog key it sends nothing.
 */
export function PageviewTracker() {
  const pathname = usePathname()
  useEffect(() => {
    capturePageview()
  }, [pathname])
  return null
}
